module.exports = __webpack_public_path__ + "roboto-regular-webfont.fed7a1b5a454836ee5ef.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-regular-webfont.ttf
// module chunks = styles